import { DocumentItemModel } from '../models'
import round from './round'

export const getEffectiveVat = (item: Pick<DocumentItemModel, 'taxFree' | 'vat'>) => (item.taxFree ? 0 : item.vat)

export const calculateItemTotals = (enterFullPriceEnabled: boolean, item: DocumentItemModel) => {
    const vat = getEffectiveVat(item)
    const total = enterFullPriceEnabled
        ? round((item.fullPrice ?? 0) / (1 + vat / 100))
        : round(round(item.salePrice * item.quantity) * (1 - item.discount / 100))
    const charge = enterFullPriceEnabled
        ? (item.fullPrice ?? 0)
        : round(round(item.salePrice * item.quantity * (1 + vat / 100)) * (1 - item.discount / 100))

    return { total, charge }
}

export const calculatePriceGroups = (enterFullPriceEnabled: boolean, items: DocumentItemModel[]) => {
    const priceGroups: {
        totalItemsPrice: number
        totalForCharge: number
        vatGroups: { [key: string]: number }
    } = { totalItemsPrice: 0, totalForCharge: 0, vatGroups: {} }

    return items.reduce((prev, item) => {
        const { total, charge } = calculateItemTotals(enterFullPriceEnabled, item)
        prev.totalItemsPrice += total
        prev.totalForCharge += charge

        if (!item.taxFree) {
            prev.vatGroups[item.vat] = (prev.vatGroups[item.vat] ?? 0) + charge - total
        }

        return prev
    }, priceGroups)
}

export const changeDocumentItemPrices = (
    enterFullPriceEnabled: boolean,
    item: DocumentItemModel,
    percentageIncrease: number,
    vat: number,
    vatEnabled: boolean, // Whether the separate bulk VAT-rate edit is enabled.
    requestedTaxFree?: boolean, // undefined preserves each item's exemption; true/false applies it to all.
    defaultVat: number = 0
): DocumentItemModel => {
    // Resolve the requested bulk change against this item's existing exemption.
    const resultingTaxFree = requestedTaxFree ?? item.taxFree
    let updatedVat = item.vat

    if (resultingTaxFree) {
        updatedVat = 0
    } else if (requestedTaxFree === false) {
        updatedVat = defaultVat
    } else if (vatEnabled) {
        updatedVat = vat
    }

    const newItem = {
        ...item,
        vat: updatedVat,
        taxFree: resultingTaxFree,
    }
    const effectiveVat = getEffectiveVat(newItem)

    if (enterFullPriceEnabled) {
        newItem.fullPrice = item.fullPrice + round((percentageIncrease / 100) * item.fullPrice)
        newItem.salePrice = round(
            round(round(newItem.fullPrice / newItem.quantity) / (1 - newItem.discount / 100) / (1 + effectiveVat / 100))
        )
    } else {
        newItem.salePrice = item.salePrice + round((percentageIncrease / 100) * item.salePrice)
        newItem.fullPrice = calculateItemTotals(false, newItem).charge
    }

    return newItem
}
